module.exports = __webpack_public_path__ + "fonts/3MCircularTT-BookItalic.2b4ac186.eot";